var _rect, _path, _path2, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3676_157",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3676_157)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V24H32V0H0Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3676_157",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V24H32V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3676_157)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3676_157",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3676_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.56299 22.2856L3.4787 25.2637L32.1599 3.23805L35.8743 -1.18743L28.3442 -2.18279L16.6458 7.30869L7.2298 13.7037L-3.56299 22.2856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.59912 24.3724L0.988295 26.1006L34.5403 -1.59835H29.5032L-2.59912 24.3724Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.563 22.2856L28.5213 25.2637L-0.159939 3.23805L-3.87427 -1.18743L3.6558 -2.18279L15.3542 7.30869L24.7702 13.7037L35.563 22.2856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3228 23.7835L31.7353 25.5117L17.4485 13.6524L13.2128 12.3273L-4.23163 -1.17185H0.805515L18.2402 12.0069L22.8712 13.5958L35.3228 23.7835Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_3676_157",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7781 -2H12.2225V8H-1.97217V16H12.2225V26H19.7781V16H34.0278V8H19.7781V-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7781 -2H12.2225V8H-1.97217V16H12.2225V26H19.7781V16H34.0278V8H19.7781V-2Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2225 -2V-4H10.2225V-2H12.2225ZM19.7781 -2H21.7781V-4H19.7781V-2ZM12.2225 8V10H14.2225V8H12.2225ZM-1.97217 8V6H-3.97217V8H-1.97217ZM-1.97217 16H-3.97217V18H-1.97217V16ZM12.2225 16H14.2225V14H12.2225V16ZM12.2225 26H10.2225V28H12.2225V26ZM19.7781 26V28H21.7781V26H19.7781ZM19.7781 16V14H17.7781V16H19.7781ZM34.0278 16V18H36.0278V16H34.0278ZM34.0278 8H36.0278V6H34.0278V8ZM19.7781 8H17.7781V10H19.7781V8ZM12.2225 0H19.7781V-4H12.2225V0ZM14.2225 8V-2H10.2225V8H14.2225ZM-1.97217 10H12.2225V6H-1.97217V10ZM0.027832 16V8H-3.97217V16H0.027832ZM12.2225 14H-1.97217V18H12.2225V14ZM14.2225 26V16H10.2225V26H14.2225ZM19.7781 24H12.2225V28H19.7781V24ZM17.7781 16V26H21.7781V16H17.7781ZM34.0278 14H19.7781V18H34.0278V14ZM32.0278 8V16H36.0278V8H32.0278ZM19.7781 10H34.0278V6H19.7781V10ZM17.7781 -2V8H21.7781V-2H17.7781Z",
    fill: "white",
    mask: "url(#path-9-inside-1_3676_157)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.289d123db184b1728b616f7921f14e4d.svg";
export { ForwardRef as ReactComponent };